import axios from 'axios'

export default {
    getCampusEvents() {
        return axios.get(process.env.VUE_APP_WP_API_URL + '/api/campus_events')
    },
    getMenusItems() {
        return axios.get(process.env.VUE_APP_WP_API_URL + '/api/menu')
    },
}
